import useInfiniteFetch from '@hooks/useInfiniteFetch';

const defaultLimit = 10;
const useCurriculumSection = (
  { lessonGroupId, url, limit = defaultLimit, classType },
  options = { fallbackData: undefined }
) => {
  const date = new Date();
  const timezoneDifference = date.getTimezoneOffset() * -1;
  const key = `${url}?timezone_difference=${timezoneDifference}&lesson_group_id=${lessonGroupId}&class_type=${classType}`;
  const {
    data: curriculumSectionData,
    isValidating,
    ...rest
  } = useInfiniteFetch(
    key,
    { limit, hasQueryParams: true },
    {
      persistSize: true,
      revalidateFirstPage: false,
      fallbackData: options.fallbackData
    }
  );
  return {
    key,
    isValidating,
    ...rest,
    curriculumSectionData
  };
};

export default useCurriculumSection;
